import React, { useEffect, useRef } from 'react'
import { Image } from "primereact/image";
import LoadingCarQuotation from "../../../assets/images/loading-car-quotation.gif";
import { checkQuoteRequestStatus } from '../../../utils/backend';
import useGetToken from '../../../store/selectors/get-token';
import { useNavigate } from 'react-router-dom';

const LoadingQuotations = () => {
  const navigate = useNavigate();
  const timerInterval = useRef(null);
  const token = useGetToken();

  useEffect(() => {
    async function fetchOrderStatus(id) {
      try {
        const response = await checkQuoteRequestStatus(token, {
          order_id: id,
        });

        if (response.success) {
          const status = response?.data?.order_status;

          if (status === 'Quotation is Ready') {
            clearInterval(timerInterval.current);
            navigate(`/get-quote/select-car-plan?token=${token}&order_id=${id}`);
          }
        } else {
          console.log(response);
          
        }
      } catch (error) {
        console.log(error);
        
      }
    }

    const queryParameters = new URLSearchParams(window.location.search);
    const orderId = queryParameters.get("order_id");

    if (orderId) {
      timerInterval.current = setInterval(() => {
        fetchOrderStatus(orderId);
      }, 3000);
    }
    
    return () => {
      if (timerInterval.current) {
        clearInterval(timerInterval.current);
      }
    };
  }, []);

  return (
    <div className='m-auto flex flex-column'>
      <div className='w-full text-center mb-42'>
        <Image
          className="px-3"
          src={LoadingCarQuotation}
          width="300"
          height="auto"
        />
      </div>

      <div className='px-64 fw-regular text-center fs-lg'>
        Hang on, we're getting the latest quotations of your car.
      </div>
    </div>
  )
}

export default LoadingQuotations